import { defineStore } from 'pinia'
import {actions} from "./actions";

export const useVideobotContentStore = defineStore('videobotContent', {
  state: () => ({ videobotContent: {} }),
  getters:{},
  actions,
})